import axios from 'axios';
import get from 'lodash/get';

export async function getLoginToken(email: string, password: string) {
  const loginUrl = process.env.REACT_APP_LOGIN_URL;

  if (!loginUrl) throw Error('REACT_APP_LOGIN_URL undefined');
  const data = formatRequestData(email, password);
  const response = await axios.post(loginUrl, data, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  const responseError = get(response, 'ERROR');
  if (responseError) throw responseError;
  return response.data.A;
}

function formatRequestData(email: string, password: string) {
  return JSON.stringify({
    // eslint-disable-next-line @typescript-eslint/camelcase
    client_id: '93b5913f-a319-4221-a217-7646e481ca03',
    email,
    password,
    // eslint-disable-next-line @typescript-eslint/camelcase
    grant_type: 'password',
  });
}
